import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqAccordion({ items = [], testid = "faq-accordion" }) {
  return (
    <Accordion type="single" collapsible className="w-full space-y-4" data-testid={testid}>
      {items.map((item, i) => (
        <AccordionItem
          key={item.id || i}
          value={`item-${i}`}
          className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] px-6 data-[state=open]:border-vantage/40"
          data-testid={`faq-item-${i}`}
        >
          <AccordionTrigger className="py-5 text-left font-heading text-base font-medium text-white hover:no-underline sm:text-lg [&[data-state=open]>svg]:text-vantage">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-sm leading-relaxed text-slate-400 sm:text-base">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
